import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import {
  FormDropDownSingleSelect,
  InputForm,
  SelectOptionTimeTemplate,
  FormPrefecturesSelect,
  FormListItem,
  FormElement,
  FormListItemGroup,
  FormListItemChild,
  FormElementContainer,
  FormElementContainerItem,
  FormElementContainerItemLabel,
  WorkHourSelectOptionTimeTemplate,
} from './CommonFormComponents';
import { FormItem } from './FormBase';
import { CcusProvider } from './FieldFormElementsCcusProvider';
import ReactDropDownCalender from './ReactDropDownCalender';
import { JvCompanyDropdown } from './dropdowns/single/JvCompany';
import { JvCompanyBranchDropdown } from './dropdowns/single/JvCompanyBranch';
import { SelectBox } from './select/SelectBox';
import { PostalCodeInput } from './forms/PostalCodeInput';
import { TelInput } from './forms/TelInput';
import { Description } from '../components/Description';
import { Confirmation } from '../components/modals/common';

import {
  API_FLAG,
  FIELD_WORK_HOUR_ZONES,
  FIELD_INPUT_RESULT,
  FIELD_ADJUST_WORK_PRINT,
  FIELD_CRANE_USE_PRINT,
  FIELD_WORK_AND_DIARY_PRINT,
  CONTRACT_FLAG,
} from '../utilities/constants';
import fetchMg from '../utilities/fetchManager';
import { createLocalEventManager } from '../utilities/EventManager';
import { messageUtility } from '../utilities/messageUtility';

import { withState } from '../hocs/withState';
import { POSTALCODE_KEY, PostalCodeValue } from '../utilities/PostalCodeStore';
import { TEL_NUMBER_KEY, TelValue } from '../utilities/TelStore';
import { ArrowDownIcon } from './icons/ArrowDownIcon';
import { TrashIcon } from './icons/TrashIcon';

const ValidationMessage = {
  company_branch_id: messageUtility.getMessage('E-000-023', '支店'),
  name: messageUtility.getMessage('E-000-024', '60'),
  address: messageUtility.getMessage('E-000-024', '255'),
  office_address: messageUtility.getMessage('E-000-024', '255'),
  charge_name: messageUtility.getMessage('E-000-024', '127'),
  charge_name_kana: messageUtility.getMessage('E-000-025', '255'),
  department: messageUtility.getMessage('E-000-026', '127'),
  start_day: messageUtility.getMessage('E-000-027', '1', '31'),
  management_no: messageUtility.getMessage('E-000-028', '16'),
};

import stylesFieldForm from '../styles/componentStyle/entrance/fieldForm.scss';
import { checkProperty, fixProperty } from '../utilities/commonUtil';
import { RadioButtonIcon } from './icons/RadioButtonIcon';
import PrimeContractorButton from './button/PrimeContractorButton';

const getValidateMessage = (validate, id) => {
  return validate ? ValidationMessage[id] || validate : null;
};

const LocalEventMg = createLocalEventManager({
  CHANGE: 'change',
  CHANGE_BRANCH_ID: 'change_branch_id',
  SET_USE_PARTNER_COMPANY_APPROVAL_FLAG:
    'set_use_partner_company_approval_flag',
});

export const FormSection = props => (
  <div className={`form-section ${stylesFieldForm['form-section']}`}>
    {props.children}
  </div>
);

/**
 * @description 元請会社入力
 */
export const CompanyName = props => (
  <FormListItem label='元請会社'>
    <FormElement>
      <span>{_.defaultTo(props.defaultValue, '')}</span>
    </FormElement>
  </FormListItem>
);

export const CcusId = props => (
  <FormListItem label='CCUS現場ID'>
    <FormElement>
      <span>{_.defaultTo(props.defaultValue, '')}</span>
      {props.isShowDeleteButton && (
        <button
          className='btn--negative'
          style={{
            marginLeft: 16,
          }}
          onClick={props.onDelete}
        >
          {messageUtility.getMessage('I-000-018')}
        </button>
      )}
    </FormElement>
  </FormListItem>
);

/**
 * @description 支店
 */
export const CompanyBranch = props => (
  <FormItem
    {...props}
    fieldCompanyBranch
    defaultValue={props.defaultValue ? props.defaultValue.id : null}
  >
    {newProps => (
      <FormListItem
        label='支店'
        required={!props.disabled || props.isRequireIconShow}
      >
        <FormElement validate={getValidateMessage(props.validate, props.id)}>
          <FormDropDownSingleSelect
            needConfirm={props.needConfirm}
            confirmTitle={messageUtility.getMessage('I-000-221')}
            confirmMessage={messageUtility.getMessage('I-000-058')}
            label='支店を指定'
            placeholder='支店名を選択'
            apiPath='/api/private/company_branches/list'
            entitiesKey='company_branches'
            disabled={props.disabled}
            isReadOnly={props.disabled}
            defaultValue={props.defaultValue}
            usersPartnerForm={props.usersPartnerForm}
            params={{
              contract_flag: CONTRACT_FLAG.yesContract.id,
              my_branch: API_FLAG.On,
            }}
            callback={value => {
              newProps.onUpdate(value.id);
              LocalEventMg.trigger('change_branch_id', value.id);
              LocalEventMg.trigger(
                'set_use_partner_company_approval_flag',
                value.use_partner_company_approval_default_flag
              );
              if (_.isFunction(props.onChangeCompanyBranch)) {
                props.onChangeCompanyBranch(value);
              }
            }}
          />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 現場名
 */
export const FieldName = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='現場名' required={!props.disabled}>
        <FormElement
          ccusComponent={props.ccusFormElement}
          validate={getValidateMessage(props.validate, props.id)}
        >
          <CcusProvider {...newProps} ccusValue={props.ccusValue}>
            <InputForm maxLength='60' />
          </CcusProvider>
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 現場郵便番号
 */
export const FieldPostalCode = props => {
  const codeValue = PostalCodeValue();
  return (
    <FormItem {...props}>
      {newProps => {
        let value = _.isString(newProps.value) ? newProps.value : '-';
        // const [num1, num2] = value.split('-');
        return (
          <FormListItem
            label='現場郵便番号'
            ccusRequired={
              _.has(props, 'ccusRequired') && props.ccusRequired === true
            }
          >
            <FormElement
              ccusComponent={props.ccusFormElement}
              validate={getValidateMessage(props.validate, props.id)}
            >
              {(value !== '-' || !props.disabled) && (
                <label htmlFor={props.id} className='input-postal'>
                  <CcusProvider {...newProps} ccusValue={props.ccusValue}>
                    <PostalCodeInput
                      {...newProps}
                      maxLength='3'
                      keyName={POSTALCODE_KEY.DISTRICT.key}
                      codeValue={codeValue}
                      params={val => {
                        let v = value.replace(/^[^-]*/, val);
                        return v === '-' ? null : v;
                      }}
                    />
                  </CcusProvider>
                  -
                  <CcusProvider {...newProps} ccusValue={props.ccusValue}>
                    <PostalCodeInput
                      {...newProps}
                      maxLength='4'
                      keyName={POSTALCODE_KEY.AREA.key}
                      codeValue={codeValue}
                      params={val => {
                        let v = value.replace(/[^-]*$/, val);
                        return v === '-' ? null : v;
                      }}
                    />
                  </CcusProvider>
                </label>
              )}
            </FormElement>
          </FormListItem>
        );
      }}
    </FormItem>
  );
};

/**
 * @description 現場都道府県
 */
export const FieldPrefecture = props => {
  return (
    <FormItem {...props}>
      {newProps => (
        <FormListItem
          label='都道府県'
          required={!props.disabled}
          ccusRequired={
            _.has(props, 'ccusRequired') && props.ccusRequired === true
          }
        >
          <FormElement
            ccusComponent={props.ccusFormElement}
            validate={getValidateMessage(props.validate, props.id)}
          >
            <CcusProvider {...newProps} ccusValue={props.ccusValue}>
              <FormPrefecturesSelect
                value={props.value || props.default_value}
                disabled={props.disabled}
              />
            </CcusProvider>
          </FormElement>
        </FormListItem>
      )}
    </FormItem>
  );
};

export const OfficePostalCode = props => {
  const codeValue = PostalCodeValue();
  return (
    <FormItem {...props}>
      {newProps => {
        const value = _.isString(newProps.value) ? newProps.value : '-';
        // const [num1, num2] = value.split('-');
        return (
          <FormListItem label='事務所郵便番号' required={!props.disabled}>
            <FormElement
              ccusComponent={props.ccusFormElement}
              validate={getValidateMessage(props.validate, props.id)}
            >
              {(value !== '-' || !props.disabled) && (
                <label htmlFor={props.id} className='input-postal'>
                  <CcusProvider {...newProps} ccusValue={props.ccusValue}>
                    <PostalCodeInput
                      {...newProps}
                      maxLength='3'
                      keyName={POSTALCODE_KEY.DISTRICT.key}
                      codeValue={codeValue}
                      params={val => {
                        let v = value.replace(/^[^-]*/, val);
                        return v === '-' ? null : v;
                      }}
                    />
                  </CcusProvider>
                  -
                  <CcusProvider {...newProps} ccusValue={props.ccusValue}>
                    <PostalCodeInput
                      {...newProps}
                      maxLength='4'
                      keyName={POSTALCODE_KEY.AREA.key}
                      codeValue={codeValue}
                      params={val => {
                        let v = value.replace(/[^-]*$/, val);
                        return v === '-' ? null : v;
                      }}
                    />
                  </CcusProvider>
                </label>
              )}
            </FormElement>
          </FormListItem>
        );
      }}
    </FormItem>
  );
};

/**
 * @description 所長名
 */
export const ChiefName = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='所長名' required={true}>
        <FormElement validate={getValidateMessage(props.validate, props.id)}>
          <InputForm {...newProps} maxLength='127' />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 所長名ふりがな
 */
export const ChiefFurigana = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='所長名ふりがな' required={true}>
        <FormElement validate={getValidateMessage(props.validate, props.id)}>
          <InputForm {...newProps} maxLength='255' />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 部署
 */
export const Department = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='部署'>
        <FormElement validate={getValidateMessage(props.validate, props.id)}>
          <InputForm {...newProps} maxLength='127' />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 事務所電話番号
 */
export const OfficeTell = props => {
  const codeValue = TelValue();
  return (
    <FormItem {...props}>
      {newProps => {
        const value = _.isString(newProps.value) ? newProps.value : '--';
        return (
          <FormListItem label='事務所電話番号' required={!props.disabled}>
            <FormElement
              ccusComponent={props.ccusFormElement}
              validate={getValidateMessage(props.validate, props.id)}
            >
              {(value !== '--' || !props.disabled) && (
                <label htmlFor={props.id} className='input-tel'>
                  <CcusProvider {...newProps} ccusValue={props.ccusValue}>
                    <TelInput
                      {...newProps}
                      maxLength='5'
                      keyName={TEL_NUMBER_KEY.AREA.key}
                      codeValue={codeValue}
                      params={val => {
                        let v = value.replace(/^[^-]*-/, `${val}-`);
                        return v === '--' ? null : v;
                      }}
                    />
                  </CcusProvider>
                  -
                  <CcusProvider {...newProps} ccusValue={props.ccusValue}>
                    <TelInput
                      {...newProps}
                      maxLength='4'
                      keyName={TEL_NUMBER_KEY.CITY.key}
                      codeValue={codeValue}
                      params={val => {
                        let v = value.replace(/-[^-]*-/, `-${val}-`);
                        return v === '--' ? null : v;
                      }}
                    />
                  </CcusProvider>
                  -
                  <CcusProvider {...newProps} ccusValue={props.ccusValue}>
                    <TelInput
                      {...newProps}
                      maxLength='4'
                      keyName={TEL_NUMBER_KEY.NUMBER.key}
                      codeValue={codeValue}
                      params={val => {
                        let v = value.replace(/-[^-]*$/, `-${val}`);
                        return v === '--' ? null : v;
                      }}
                    />
                  </CcusProvider>
                </label>
              )}
            </FormElement>
          </FormListItem>
        );
      }}
    </FormItem>
  );
};

/**
 * @description Buildee担当者
 */
export class BuildeeTantousya extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branch_id: 0,
    };

    LocalEventMg.addEventListener('change_branch_id', id => {
      if (_.isNumber(id) && this.state.branch_id !== id) {
        this.setState({ branch_id: id });
      }
    });
    this.params =
      this.props.isEdit && this.props.fieldId
        ? { field_id: this.props.fieldId }
        : null;
  }

  render() {
    return (
      <FormItem {...this.props}>
        {newProps => (
          <FormListItem label='Buildee担当者' required={!this.props.disabled}>
            <FormElement
              validate={getValidateMessage(this.props.validate, this.props.id)}
            >
              <FormDropDownSingleSelect
                label='担当者を指定'
                placeholder='担当者を選択'
                apiPath={
                  this.state.branch_id === 0
                    ? null
                    : `/api/private/company_branches/${
                        this.state.branch_id
                      }/manager_lists`
                }
                params={this.params}
                entitiesKey='user_lists'
                itemKey='fullname'
                searchKey='fullname'
                disabled={this.props.disabled}
                isReadOnly={this.props.disabled}
                defaultValue={this.props.defaultValue}
                fieldRegister={this.props.fieldRegister}
                callback={value => {
                  LocalEventMg.trigger('change', value);
                  newProps.onUpdate(value.id);
                }}
              />
            </FormElement>
          </FormListItem>
        )}
      </FormItem>
    );
  }
}

/**
 * @description Buildee担当者メールアドレス
 */
export class BuildeeTantouEmail extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { email: _.defaultTo(props.defaultValue, ''), id: null };

    props.EventMg.addEventListener('change_value', (params_id, params) => {
      if (params_id === 'buildee_user_id') {
        let id = params.buildee_user_id;
        if (id === this.state.id || _.isObject(params.buildee_user_id)) {
          return;
        }
        if (id) {
          // Buildee担当者が選択された場合
          fetchMg.GetAjax(`/api/private/users/${id}`).then(data => {
            if (data.result) {
              let { email } = data.data.entities.user;
              this.setState({ email, id });
            }
          });
        } else {
          // Buildee担当者が削除された場合
          this.setState({ email: '', id: '' });
        }
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.email && nextProps.defaultValue) {
      this.setState({ email: nextProps.defaultValue });
    }
  }

  render() {
    return (
      <FormListItem label='Buildee担当者メールアドレス'>
        <FormElement>
          <span>{this.state.email}</span>
        </FormElement>
      </FormListItem>
    );
  }
}

/**
 * @description 着工日
 */
export const GroundBreakingDate = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem id={props.id} label='着工日' required={!props.disabled}>
        <FormElement
          ccusComponent={props.ccusFormElement}
          validate={getValidateMessage(props.validate, props.id)}
        >
          <div className='dropdown-calender --col-md-10 --col-xs-10'>
            {/* ReactDropDownCalenderでprops.validateが関数として実行されるので無効にする */}
            <CcusProvider
              {...newProps}
              ccusValue={props.ccusValue}
              validate={false}
            >
              <ReactDropDownCalender
                name={props.id}
                disabled={props.disabled}
                value={newProps.value}
                DisplayText={() =>
                  !_.isEmpty(props.DisplayText) ? props.DisplayText : undefined
                }
                style={{ width: '100%' }}
                onChange={value => {
                  newProps.onUpdate(value);
                }}
              />
            </CcusProvider>
          </div>
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 竣工予定日
 */
export const CompleteScheduleDate = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem id={props.id} label='竣工予定日' required={!props.disabled}>
        <FormElement
          ccusComponent={props.ccusFormElement}
          validate={getValidateMessage(props.validate, props.id)}
        >
          <div className='dropdown-calender --col-md-10 --col-xs-10'>
            {/* ReactDropDownCalenderでprops.validateが関数として実行されるので無効にする */}
            <CcusProvider
              {...newProps}
              ccusValue={props.ccusValue}
              validate={false}
            >
              <ReactDropDownCalender
                name={props.id}
                disabled={props.disabled}
                value={newProps.value}
                DisplayText={() =>
                  !_.isEmpty(props.DisplayText) ? props.DisplayText : undefined
                }
                onChange={value => {
                  newProps.onUpdate(value);
                }}
              />
            </CcusProvider>
          </div>
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * Buildee利用終了日
 */
export const BuildeeEndDay = props => {
  if (
    !(
      fixProperty(props, 'value,onUpdate,disabled,validate') ||
      fixProperty(props, 'value,onUpdate,disabled,EventMg,validate')
    )
  ) {
    console.error('FieldFormElements.jsx BuildeeEndDay', props);
    throw new Error('FieldFormElements.jsx BuildeeEndDay');
  }

  return (
    <FormListItem label='Buildee利用終了日' required={!props.disabled}>
      <FormElement
        validate={getValidateMessage(props.validate, props.id)}
        info={
          !props.disabled &&
          'Buildee利用終了日を超えると、現場を利用できなくなります。'
        }
      >
        <div className='dropdown-calender --col-md-10 --col-xs-10'>
          <ReactDropDownCalender
            name={props.id}
            disabled={props.disabled}
            value={props.value}
            DisplayText={() =>
              !_.isEmpty(props.DisplayText) ? props.DisplayText : undefined
            }
            onChange={value => {
              props.onUpdate(value);
            }}
          />
        </div>
      </FormElement>
    </FormListItem>
  );
};

/**
 * @description 作業時間帯
 */
export const WorkTimeType = props => (
  <FormListItem
    label='作業時間帯'
    required={!props.disabled}
    isBorder={!!props.validate.work_hour_type}
  >
    <FormElement
      validate={getValidateMessage(props.validate.work_hour_type, props.id)}
    >
      <FormItem
        {...props}
        id='work_hour_zone_day_flag'
        defaultValue={props.defaultValue.work_hour_zone_day_flag}
      >
        {newProps => {
          return (
            (!newProps.disabled ||
              newProps.value === FIELD_WORK_HOUR_ZONES.on.id) && (
              <div className='work-times__item work_hour_zone'>
                {!newProps.disabled && (
                  <label className='checkbox'>
                    <input
                      name='checkbox1'
                      type='checkbox'
                      disabled={newProps.disabled}
                      checked={newProps.value === FIELD_WORK_HOUR_ZONES.on.id}
                      onChange={e => {
                        newProps.onUpdate(
                          e.target.checked
                            ? FIELD_WORK_HOUR_ZONES.on.id
                            : FIELD_WORK_HOUR_ZONES.off.id
                        );
                        if (typeof props.onChangeCheck === 'function') {
                          props.onChangeCheck(newProps, e.target.checked);
                        }
                      }}
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                    昼間
                  </label>
                )}
                {newProps.disabled &&
                  newProps.value === FIELD_WORK_HOUR_ZONES.on.id &&
                  '昼間'}
              </div>
            )
          );
        }}
      </FormItem>
      <FormItem
        {...props}
        id='work_hour_zone_night_flag'
        defaultValue={props.defaultValue.work_hour_zone_night_flag}
      >
        {newProps => {
          return (
            (!newProps.disabled ||
              newProps.value === FIELD_WORK_HOUR_ZONES.on.id) && (
              <div className='work-times__item work_hour_zone'>
                {!newProps.disabled && (
                  <label className='checkbox'>
                    <input
                      name='checkbox1'
                      type='checkbox'
                      disabled={newProps.disabled}
                      checked={newProps.value === FIELD_WORK_HOUR_ZONES.on.id}
                      onChange={e => {
                        newProps.onUpdate(
                          e.target.checked
                            ? FIELD_WORK_HOUR_ZONES.on.id
                            : FIELD_WORK_HOUR_ZONES.off.id
                        );
                        if (typeof props.onChangeCheck === 'function') {
                          props.onChangeCheck(newProps, e.target.checked);
                        }
                      }}
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                    夜間
                  </label>
                )}
                {newProps.disabled &&
                  newProps.value === FIELD_WORK_HOUR_ZONES.on.id &&
                  '夜間'}
              </div>
            )
          );
        }}
      </FormItem>
      <FormItem
        {...props}
        id='work_hour_zone_midnight_flag'
        defaultValue={props.defaultValue.work_hour_zone_midnight_flag}
      >
        {newProps => {
          return (
            (!newProps.disabled ||
              newProps.value === FIELD_WORK_HOUR_ZONES.on.id) && (
              <div className='work-times__item work_hour_zone'>
                {!newProps.disabled && (
                  <label className='checkbox'>
                    <input
                      name='checkbox1'
                      type='checkbox'
                      disabled={newProps.disabled}
                      checked={newProps.value === FIELD_WORK_HOUR_ZONES.on.id}
                      onChange={e => {
                        newProps.onUpdate(
                          e.target.checked
                            ? FIELD_WORK_HOUR_ZONES.on.id
                            : FIELD_WORK_HOUR_ZONES.off.id
                        );
                        if (typeof props.onChangeCheck === 'function') {
                          props.onChangeCheck(newProps, e.target.checked);
                        }
                      }}
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                    深夜
                  </label>
                )}
                {newProps.disabled &&
                  newProps.value === FIELD_WORK_HOUR_ZONES.on.id &&
                  '深夜'}
              </div>
            )
          );
        }}
      </FormItem>
    </FormElement>
  </FormListItem>
);

/**
 * @description 労働開始時刻（早出終了時刻）
 * @description 労働終了時刻（残業開始時刻）
 * @description 作業時間帯バー表示の開始時刻
 * @description 作業時間帯バー表示の終了時刻
 * @description 予定→実施入力反映時刻
 * @description 上記のフォームをネストしたコンポーネント
 */
export const NestForm = props => {
  const getValidateMessageWorkHour = (type = '') => {
    if (!props.validate) {
      return null;
    }
    const keys = [
      'work_copy_time',
      'work_end_time',
      'work_start_time',
      'earlytime_end',
      'overtime_start',
    ];
    let result = '';
    for (let i in keys) {
      const key = `${keys[i]}${type}`;
      if (props.validate[key] && result !== props.validate[key]) {
        result += props.validate[key];
      }
    }
    return result;
  };
  const WORK_HOUR_ZONE_FLAG = {
    DAY_FLAG: props.defaultValue.work_hour_zone_day_flag === 1,
    NIGHT_FLAG: props.defaultValue.work_hour_zone_night_flag === 1,
    MIDNIGHT_FLAG: props.defaultValue.work_hour_zone_midnight_flag === 1,
  };
  const EMPTY_WORK_HOUR_ZONE = !(
    WORK_HOUR_ZONE_FLAG.DAY_FLAG ||
    WORK_HOUR_ZONE_FLAG.NIGHT_FLAG ||
    WORK_HOUR_ZONE_FLAG.MIDNIGHT_FLAG
  );

  return (
    !EMPTY_WORK_HOUR_ZONE && (
      <FormListItemGroup isBorder={false}>
        {WORK_HOUR_ZONE_FLAG.DAY_FLAG && (
          <FormListItemChild label='昼間' required={!props.disabled}>
            <FormElement validate={getValidateMessageWorkHour()}>
              <FormListItem label='労働時刻' isBorder={false}>
                <FormElement
                  info={
                    !props.disabled &&
                    '労働時刻外の時間帯が早出・残業にあたります。'
                  }
                >
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='earlytime_end'
                      defaultValue={props.defaultValue.earlytime_end}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                    <span className='input-date-range__bar'>～</span>
                    <FormItem
                      {...props}
                      id='overtime_start'
                      defaultValue={props.defaultValue.overtime_start}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
              <FormListItem label='作業時間帯バー表示' isBorder={false}>
                <FormElement>
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='work_start_time'
                      defaultValue={props.defaultValue.work_start_time}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                    <span className='input-date-range__bar'>～</span>
                    <FormItem
                      {...props}
                      id='work_end_time'
                      defaultValue={props.defaultValue.work_end_time}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
              <FormListItem label='作業予定→作業実績反映時刻' isBorder={false}>
                <FormElement>
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='work_copy_time'
                      defaultValue={props.defaultValue.work_copy_time}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
            </FormElement>
          </FormListItemChild>
        )}
        {WORK_HOUR_ZONE_FLAG.NIGHT_FLAG && (
          <FormListItemChild
            label='夜間'
            required={!props.disabled}
            isSpace={WORK_HOUR_ZONE_FLAG.DAY_FLAG}
          >
            <FormElement validate={getValidateMessageWorkHour('_night')}>
              <FormListItem label='労働時刻' isBorder={false}>
                <FormElement
                  info={
                    !props.disabled &&
                    '労働時刻外の時間帯が早出・残業にあたります。'
                  }
                >
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='earlytime_end_night'
                      defaultValue={props.defaultValue.earlytime_end_night}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                    <span className='input-date-range__bar'>～</span>
                    <FormItem
                      {...props}
                      id='overtime_start_night'
                      defaultValue={props.defaultValue.overtime_start_night}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
              <FormListItem label='作業時間帯バー表示' isBorder={false}>
                <FormElement>
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='work_start_time_night'
                      defaultValue={props.defaultValue.work_start_time_night}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                    <span className='input-date-range__bar'>～</span>
                    <FormItem
                      {...props}
                      id='work_end_time_night'
                      defaultValue={props.defaultValue.work_end_time_night}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
              <FormListItem label='作業予定→作業実績反映時刻' isBorder={false}>
                <FormElement>
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='work_copy_time_night'
                      defaultValue={props.defaultValue.work_copy_time_night}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
            </FormElement>
          </FormListItemChild>
        )}
        {WORK_HOUR_ZONE_FLAG.MIDNIGHT_FLAG && (
          <FormListItemChild
            label='深夜'
            required={!props.disabled}
            isSpace={
              WORK_HOUR_ZONE_FLAG.DAY_FLAG || WORK_HOUR_ZONE_FLAG.NIGHT_FLAG
            }
          >
            <FormElement validate={getValidateMessageWorkHour('_midnight')}>
              <FormListItem label='労働時刻' isBorder={false}>
                <FormElement
                  info={
                    !props.disabled &&
                    '労働時刻外の時間帯が早出・残業にあたります。'
                  }
                >
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='earlytime_end_midnight'
                      defaultValue={props.defaultValue.earlytime_end_midnight}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                    <span className='input-date-range__bar'>～</span>
                    <FormItem
                      {...props}
                      id='overtime_start_midnight'
                      defaultValue={props.defaultValue.overtime_start_midnight}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
              <FormListItem label='作業時間帯バー表示' isBorder={false}>
                <FormElement>
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='work_start_time_midnight'
                      defaultValue={props.defaultValue.work_start_time_midnight}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                    <span className='input-date-range__bar'>～</span>
                    <FormItem
                      {...props}
                      id='work_end_time_midnight'
                      defaultValue={props.defaultValue.work_end_time_midnight}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
              <FormListItem label='作業予定→作業実績反映時刻' isBorder={false}>
                <FormElement>
                  <div className='input-date-range'>
                    <FormItem
                      {...props}
                      id='work_copy_time_midnight'
                      defaultValue={props.defaultValue.work_copy_time_midnight}
                    >
                      {newProps => <TimeSelectForm {...newProps} />}
                    </FormItem>
                  </div>
                </FormElement>
              </FormListItem>
            </FormElement>
          </FormListItemChild>
        )}
      </FormListItemGroup>
    )
  );
};

const formatArray = array => {
  if (_.isArray(array)) {
    for (let i in array) {
      array[i] = {
        start_date: array[i].start_date,
        worker_work_time: array[i].worker_work_time,
        manager_work_time: array[i].manager_work_time,
      };
    }

    return array;
  }

  return [{}];
};

/**
 * @description 1日あたりの労働時間
 */
export const DailyWorkTime = props => (
  <FormItem {...props} defaultValue={formatArray(props.defaultValue)}>
    {newProps => <DailyWorkTimeWarpper {...newProps} />}
  </FormItem>
);

/**
 * @description 1日あたりの労働時間のラッパークラス
 */
export class DailyWorkTimeWarpper extends React.Component {
  componentWillMount() {
    if (this.props.isRegister === true) {
      const data = [
        {
          end_date: moment()
            .subtract(1, 'd')
            .format('YYYY/MM/DD'),
          start_date: moment().format('YYYY/MM/DD'),
          worker_work_time: '08:00:00',
          manager_work_time: '08:00:00',
        },
      ];
      this.props.onUpdate(data);
    }
  }

  componentDidMount() {
    this.props.EventMg.addEventListener('change_value', (id, params) => {
      if (id === 'groundbreaking_date' && params.groundbreaking_date) {
        setTimeout(() => {
          //着工日を取得
          const list = this.props.value;
          const value = _.clone(list[0]) || {};
          value.start_date = params.groundbreaking_date;
          list[0] = value;
          this.props.onUpdate(list);
        }, 100);
      }
    });
  }

  onAdd() {
    let data = this.props.value;
    data[data.length - 1].end_date = moment()
      .subtract(1, 'd')
      .format('YYYY/MM/DD');
    data.push({
      start_date: moment().format('YYYY/MM/DD'),
      worker_work_time: '08:00:00',
      manager_work_time: '08:00:00',
    });
    this.props.onUpdate(data);
  }

  onUpdate(index, key, value) {
    let data = this.props.value;
    if (_.isUndefined(data[0].start_date)) {
      // 1行目の1日あたりの労働時間_適用開始日に値が設定されていない場合
      data[0].start_date = moment().format('YYYY/MM/DD');
    }
    let _obj = _.clone(data[index]);
    if (key === 'delete') {
      if (data.length - 1 === index) {
        //末尾を削除
        delete data[index - 1].end_date;
      } else {
        //末尾以外を削除
        data[index - 1].end_date = moment(
          data[index + 1].start_date,
          'YYYY/MM/DD'
        )
          .subtract(1, 'd')
          .format('YYYY/MM/DD');
      }
      data.splice(index, 1);
    } else {
      if (key === 'start_date' && index > 0) {
        // end_dateを設定
        data[index - 1].end_date = moment(value, 'YYYY/MM/DD')
          .subtract(1, 'd')
          .format('YYYY/MM/DD');
      }
      _obj[key] = value;
      data[index] = _obj;
    }

    this.props.onUpdate(data);
  }

  render() {
    const workDaySize = this.props.value ? this.props.value.length : 0;
    return (
      <FormListItem label='1日あたりの労働時間' required={!this.props.disabled}>
        <FormElement>
          {_.map(this.props.value, (value, index) => (
            <WorkDayTimeTemplate
              {...this.props}
              value={value}
              index={index}
              key={index}
              validate={this.props.validate}
              onUpdate={(key, val) => this.onUpdate(index, key, val)}
              workDaySize={workDaySize}
            />
          ))}
          {!this.props.disabled ? (
            <FormListItem isBorder={false}>
              <FormElement>
                <FormElementContainer>
                  <FormElementContainerItem>
                    <button
                      className='btn--sub'
                      onClick={this.onAdd.bind(this)}
                    >
                      入力枠を追加する
                    </button>
                  </FormElementContainerItem>
                </FormElementContainer>
              </FormElement>
            </FormListItem>
          ) : null}
        </FormElement>
      </FormListItem>
    );
  }
}

/**
 * @description 1日あたりの労働時間の追加テンプレート
 */
const WorkDayTimeTemplate = ({
  id,
  index,
  value,
  disabled,
  onUpdate,
  validate,
  workDaySize,
}) => {
  // validateを取得
  if (_.isObject(validate) && validate[index]) {
    validate = validate[index];
  } else {
    validate = {};
  }

  return (
    <FormListItem
      isBorder={
        index < workDaySize - 1 || (!disabled && index === workDaySize - 1)
      }
    >
      <FormElement>
        {index !== 0 && !disabled && (
          <button
            className='btn-icon--xs daily-work-time__trash-icon'
            onClick={() => {
              onUpdate('delete');
            }}
          >
            <TrashIcon className='icon--2_4x form-list__trash-icon' />
          </button>
        )}
        <FormElementContainer>
          <FormElementContainerItem>
            <FormElement validate={getValidateMessage(validate.start_date, id)}>
              <FormElementContainerItemLabel>
                適用開始日
              </FormElementContainerItemLabel>
              <ReactDropDownCalender
                name='start_date'
                value={value.start_date}
                disabled={disabled || index === 0}
                onChange={val => {
                  onUpdate('start_date', val);
                }}
              />
            </FormElement>
          </FormElementContainerItem>
          <FormElementContainerItem>
            <FormElement
              validate={getValidateMessage(
                validate.worker_work_time || validate.manager_work_time,
                id
              )}
            >
              <FormElementContainerItemLabel>
                作業員
              </FormElementContainerItemLabel>
              <div className='input-date-range input-date-range--work-day-time'>
                <select
                  value={_.defaultTo(value.worker_work_time, '')}
                  disabled={disabled}
                  className='input-date-range__select'
                  onChange={e => {
                    onUpdate('worker_work_time', e.target.value);
                  }}
                >
                  <WorkHourSelectOptionTimeTemplate
                    start='00:00'
                    end='23:45'
                    step={15}
                  />
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>

              <FormElementContainerItemLabel isSpace={true}>
                社員（外注含む）
              </FormElementContainerItemLabel>
              <div className='input-date-range input-date-range--work-day-time'>
                <select
                  value={_.defaultTo(value.manager_work_time, '')}
                  disabled={!!disabled}
                  className='input-date-range__select'
                  onChange={e => {
                    onUpdate('manager_work_time', e.target.value);
                  }}
                >
                  <WorkHourSelectOptionTimeTemplate
                    start='00:00'
                    end='23:45'
                    step={15}
                  />
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
            </FormElement>
          </FormElementContainerItem>
        </FormElementContainer>
      </FormElement>
    </FormListItem>
  );
};

/**
 * @description 月次開始日
 */
export const StartDay = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='月次開始日' required={!props.disabled}>
        <FormElement
          validate={getValidateMessage(props.validate, props.id)}
          info={
            !props.disabled &&
            '出面及び支払い内訳書の開始日として使用されます。'
          }
        >
          <input
            type='text'
            placeholder='（例）1'
            maxLength='2'
            value={_.defaultTo(newProps.value, '')}
            disabled={props.disabled}
            onChange={e => {
              newProps.onUpdate(e.target.value);
            }}
            onBlur={() => {
              newProps.onValidationCheck();
            }}
          />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 自動ロックまでの日数
 */
export const ApprovalDays = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='自動ロックまでの日数' required={!props.disabled}>
        <FormElement
          validate={getValidateMessage(props.validate, props.id)}
          info={
            !props.disabled &&
            '入力した日数経過後、自動的に作業が承認されます。（0指定にて自動ロックを行いません）'
          }
        >
          <input
            type='text'
            placeholder='（例）1'
            maxLength='3'
            value={_.defaultTo(newProps.value, '')}
            disabled={props.disabled}
            onChange={e => {
              newProps.onUpdate(e.target.value);
            }}
            onBlur={() => {
              newProps.onValidationCheck();
            }}
          />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 協力会社承認機能
 */
export class UsePartnerCompanyApprovalFlag extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      usePartnerCompanyApprovalFlag: null,
    };
  }

  componentDidMount() {
    LocalEventMg.addEventListener(
      'set_use_partner_company_approval_flag',
      usePartnerCompanyApprovalDefaultFlag => {
        if (this.props.isRegister) {
          this.props.EventMg.trigger('input_change_value', {
            id: 'use_partner_company_approval_flag',
            value: usePartnerCompanyApprovalDefaultFlag,
          });
        }
      }
    );

    this.props.EventMg.addEventListener('change_value', (id, params) => {
      if (id === 'use_partner_company_approval_flag') {
        this.setState({
          usePartnerCompanyApprovalFlag:
            params.use_partner_company_approval_flag,
        });
      }
    });
  }

  render() {
    const { usePartnerCompanyApprovalFlag } = this.state;

    return (
      <FormItem {...this.props}>
        {newProps => (
          <FormListItem label='協力会社承認機能'>
            <FormElement>
              {this.props.disabled ? (
                <span>
                  {usePartnerCompanyApprovalFlag === API_FLAG.On ? 'ON' : 'OFF'}
                </span>
              ) : (
                <div className='form-list-radio'>
                  <div className='form-list-radio__item'>
                    <label className='radio'>
                      <InputForm
                        {...newProps}
                        value={usePartnerCompanyApprovalFlag === API_FLAG.On}
                        type='radio'
                        params={API_FLAG.On}
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>ON</span>
                    </label>
                  </div>
                  <div className='form-list-radio__item'>
                    <label className='radio'>
                      <InputForm
                        {...newProps}
                        value={usePartnerCompanyApprovalFlag === API_FLAG.Off}
                        type='radio'
                        params={API_FLAG.Off}
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>OFF</span>
                    </label>
                  </div>
                </div>
              )}
            </FormElement>
          </FormListItem>
        )}
      </FormItem>
    );
  }
}

/**
 * @description 作業実績の入力を促す表示 (協力会社)
 */
export const PartnerInputResultFlag = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItemGroup label='作業実績の入力を促す表示'>
        <FormListItemChild label='協力会社'>
          <FormElement validate={getValidateMessage(props.validate, props.id)}>
            {props.disabled ? (
              <span>
                {newProps.value === FIELD_INPUT_RESULT.on.id ? 'ON' : 'OFF'}
              </span>
            ) : (
              <div className='form-list-radio'>
                <div className='form-list-radio__item'>
                  <label className='radio'>
                    <InputForm
                      {...newProps}
                      value={newProps.value === FIELD_INPUT_RESULT.on.id}
                      type='radio'
                      params={FIELD_INPUT_RESULT.on.id}
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>ON</span>
                  </label>
                </div>
                <div className='form-list-radio__item'>
                  <label className='radio'>
                    <InputForm
                      {...newProps}
                      value={newProps.value === FIELD_INPUT_RESULT.off.id}
                      type='radio'
                      params={FIELD_INPUT_RESULT.off.id}
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>OFF</span>
                  </label>
                </div>
              </div>
            )}
          </FormElement>
        </FormListItemChild>
      </FormListItemGroup>
    )}
  </FormItem>
);

/**
 * @description 作業安全指示書とKY記録表の印刷方法
 */
export const AdjustWorkPrintFlag = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label={`作業安全指示書と\nKY記録表の印刷方法`}>
        <FormElement validate={getValidateMessage(props.validate, props.id)}>
          {props.disabled ? (
            <span>
              {newProps.value === FIELD_ADJUST_WORK_PRINT.separate.id
                ? '分けて印刷'
                : 'まとめて印刷'}
            </span>
          ) : (
            <div className='form-list-radio'>
              <div className='form-list-radio__item'>
                <label className='radio'>
                  <InputForm
                    {...newProps}
                    value={
                      newProps.value === FIELD_ADJUST_WORK_PRINT.separate.id
                    }
                    type='radio'
                    params={FIELD_ADJUST_WORK_PRINT.separate.id}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>分けて印刷</span>
                </label>
              </div>

              <div className='form-list-radio__item'>
                <label className='radio'>
                  <InputForm
                    {...newProps}
                    value={
                      newProps.value === FIELD_ADJUST_WORK_PRINT.together.id
                    }
                    type='radio'
                    params={FIELD_ADJUST_WORK_PRINT.together.id}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>まとめて印刷</span>
                </label>
              </div>
            </div>
          )}
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 揚重作業計画・作業指示書の印刷向き
 */
export const CraneUsePrintFlag = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label={`揚重作業計画・\n作業指示書の印刷向き`}>
        <FormElement validate={getValidateMessage(props.validate, props.id)}>
          {props.disabled ? (
            <span>
              {newProps.value === FIELD_CRANE_USE_PRINT.side.id
                ? 'A4横型'
                : 'A4縦型'}
            </span>
          ) : (
            <div className='form-list-radio'>
              <div className='form-list-radio__item'>
                <label className='radio'>
                  <InputForm
                    {...newProps}
                    value={newProps.value === FIELD_CRANE_USE_PRINT.side.id}
                    type='radio'
                    params={FIELD_CRANE_USE_PRINT.side.id}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>A4横型</span>
                </label>
              </div>
              <div className='form-list-radio__item'>
                <label className='radio'>
                  <InputForm
                    {...newProps}
                    value={newProps.value === FIELD_CRANE_USE_PRINT.vertical.id}
                    type='radio'
                    params={FIELD_CRANE_USE_PRINT.vertical.id}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>A4縦型</span>
                </label>
              </div>
            </div>
          )}
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description 作業間連絡及び調整実施記録（安全衛生日誌有）の印刷方法
 */
export const WorkAndDiaryPrintFlag = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem
        label={`作業間連絡及び調整実施記録\n（安全衛生日誌有）の印刷方法`}
      >
        <FormElement validate={getValidateMessage(props.validate, props.id)}>
          {props.disabled ? (
            <span>
              {newProps.value === FIELD_WORK_AND_DIARY_PRINT.adjustment.id
                ? '調整日の作業内容を出力'
                : '予定日の作業内容のみ出力'}
            </span>
          ) : (
            <div className='form-list-radio'>
              <div className='form-list-radio__item'>
                <label className='radio'>
                  <InputForm
                    {...newProps}
                    value={
                      newProps.value ===
                      FIELD_WORK_AND_DIARY_PRINT.adjustment.id
                    }
                    type='radio'
                    params={FIELD_WORK_AND_DIARY_PRINT.adjustment.id}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>調整日の作業内容を出力</span>
                </label>
              </div>
              <div className='form-list-radio__item'>
                <label className='radio'>
                  <InputForm
                    {...newProps}
                    value={
                      newProps.value === FIELD_WORK_AND_DIARY_PRINT.plan.id
                    }
                    type='radio'
                    params={FIELD_WORK_AND_DIARY_PRINT.plan.id}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>予定日の作業内容のみ出力</span>
                </label>
              </div>
            </div>
          )}
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description  工事管理番号
 */
export const ManagementNo = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem label='工事管理番号' required={!props.disabled}>
        <FormElement
          validate={getValidateMessage(props.validate, props.id)}
          info={
            !props.disabled &&
            '支店で定められている工事管理番号を半角英数字で入力してください。'
          }
        >
          <input
            type='text'
            maxLength='16'
            value={_.defaultTo(newProps.value, '')}
            disabled={props.disabled}
            onChange={e => {
              newProps.onUpdate(e.target.value);
            }}
            onBlur={() => {
              newProps.onValidationCheck();
            }}
          />
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

/**
 * @description JVの追加フォーム
 */
export class JV extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      branch_id: 0,
      jvsList: [{}],
    };

    this.stateFlg = false;
    this.companyId = parseInt(sessionStorage.getItem('company_id'), 10); // 元請ID
    this.noValueJvFlg = false;

    LocalEventMg.addEventListener('change_branch_id', id => {
      const jvsList = this.state.branch_id !== id ? [] : _.cloneDeep(this.state.jvsList);
      this.setState({ branch_id: id, jvsList }, () => {
        this.props.EventMg.trigger('input_change_value', {
          id: 'jvs',
          value: jvsList,
        });
      });
    });
  }

  componentWillUnmount() {
    LocalEventMg.clearEventListener('change_branch_id');
  }

  componentDidUpdate(prevProps) {
    if (!_.isUndefined(this.props.defaultValue) && this.stateFlg !== true) {
      // 詳細、編集画面遷移時、1度だけデフォルトの値をstateに設定
      this.stateFlg = true;

      this.setState({
        jvsList: _.defaultTo(this.props.defaultValue, this.props.jvsParams),
      });
      return;
    }

    if (
      _.isNull(this.state.jvsList) &&
      prevProps.defaultValue !== this.props.defaultValue
    ) {
      this.setState({
        jvsList: this.props.defaultValue,
      });
    }

    if (
      this.props.companyBranchId !== prevProps.companyBranchId &&
      prevProps.fieldsForm !== true
    ) {
      // 支店が変更された場合
      // ※支店を操作することが出来ない現場編集画面は除外
      let isDeselectedCompanyBranch = false;
      const jvsList = _.map(this.state.jvsList, jvs => {
        if (
          jvs.company_id === this.companyId &&
          jvs.company_branch_id === this.props.companyBranchId
        ) {
          isDeselectedCompanyBranch = true;
          // JV会社に自社を選択し、支店変更により支店とJV支店が被った場合、
          // JV支店を削除
          const newJvs = _.cloneDeep(jvs);
          delete newJvs.company_branch_id;
          delete newJvs.company_branch_name;
          return newJvs;
        } else {
          return jvs;
        }
      });

      // 支店が解除された場合は反映する
      // 自コンポーネントとEventMg経由で親コンポーネントも更新する
      if (isDeselectedCompanyBranch) {
        this.setState({ jvsList });
        this.props.EventMg.trigger('input_change_value', {
          id: 'jvs',
          value: jvsList,
        });
      }
    }
  }

  /**
   * @description JV会社を設定
   * @param {string} item 選択JV会社
   * @param {int} index JVコンポーネント要素番号
   */
  setJvCompany(item, index) {
    let jvsList = [...this.state.jvsList];
    if (item.id === jvsList[index].company_id) {
      // 同じJV会社を選択した場合
      return false;
    }
    jvsList[index].company_id = item.id;
    jvsList[index].company_name = item.name;
    jvsList[index].companyBranches = item.company_branches;
    if (_.has(jvsList[index], 'company_branch_id')) {
      // JV支店を選択した状態でJV会社を変更した場合、
      // JV支店情報を削除
      delete jvsList[index].company_branch_id;
      delete jvsList[index].company_branch_name;
    }
    this.setState({ jvsList });
    return true;
  }

  clearJvCompany(item, index) {
    console.log('clear:', item, index);
    let jvsList = [...this.state.jvsList];
    delete jvsList[index];
    this.setState({ jvsList });
  }

  /**
   * @description JV支店を設定
   * @param {string} item 選択JV支店
   * @param {int} index JVコンポーネント要素番号
   */
  setJvCompanyBranch(item, index) {
    let jvsList = [...this.state.jvsList];
    jvsList[index].company_branch_id = item.id;
    jvsList[index].company_branch_name = item.name;
    this.setState({ jvsList });
  }

  /**
   * @description JVコンポーネント追加
   */
  addJvForm() {
    let jvsList = !_.isEmpty(this.state.jvsList) ? [...this.state.jvsList] : [];
    jvsList.push({ onRegister: true });
    this.setState({ jvsList });
  }

  /**
   * @description JV会社を設定
   * @param {int} index JVコンポーネント要素番号
   * @param {object} newProps 新しいprops
   */
  removeJvForm(index, newProps) {
    let jvsList = [...this.state.jvsList];
    jvsList.splice(index, 1);
    this.setState({ jvsList }, () => {
      newProps.onUpdate(this.state.jvsList);
    });
  }

  /**
   * @description JV会社が設定されたか確認
   * @param {int} index JVコンポーネント要素番号
   */
  getHaveCompanyFlg(index) {
    if (_.isEmpty(this.state.jvsList)) {
      return false;
    }
    const jv = this.state.jvsList[index];
    let haveCompany = false;
    if (!_.isEmpty(jv)) {
      if (jv.company_id === 0) {
        haveCompany = true;
      } else if (!_.isNull(jv.company_id) && !_.isUndefined(jv.company_id)) {
        haveCompany = true;
      }
    }
    return haveCompany;
  }

  render() {
    const { jvsList } = this.state;
    const jvsSize = jvsList ? jvsList.length : 0;
    const getValidate = index => {
      let validate = '';
      if (_.isObject(this.props.validate)) {
        let obj = this.props.validate[index];
        if (!_.isUndefined(obj)) {
          validate = _.isString(obj)
            ? obj
            : '元請会社と支店を選択してください。';
        }
      }
      return validate;
    };

    this.noValueJvFlg = _.some(jvsList, jv => {
      const company_id = jv.company_id === 0 ? true : jv.company_id;
      const company_branch_id =
        jv.company_branch_id === 0 ? true : jv.company_branch_id;
      return !company_id || !company_branch_id;
    });

    return (
      <React.Fragment>
        <FormItem
          {...this.props}
          id='jvs'
          defaultValue={_.defaultTo(this.props.jvsParams, [{}])}
        >
          {newProps => (
            <FormListItem label='JV設定'>
              <FormElement className='form-list__element FieldJvSetting'>
                {!this.props.disabled && (
                  <FormListItem>
                    <Description type='primary'>
                      JV構成会社に追加したい会社名を入力して検索してください。
                      <br />
                      Buildeeを元請としてご利用中でない会社の場合、検索結果に表示されません。
                      <br />
                      追加したい会社が、Buildeeをご利用中でない場合は、JV構成会社に追加したい会社様からサブJVとしてのBuildee利用申込が必要となります。
                      <br />
                      <a
                        className='clickable-text'
                        data-testid='worker_insurance_manual_download_link'
                        href='https://service.buildee.jp/flow/prime/'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        こちら
                      </a>
                      からお申込みが可能です。
                    </Description>
                  </FormListItem>
                )}
                {_.map(jvsList, (jv, index) => {
                  const _enable = this.getHaveCompanyFlg(index);
                  return (
                    <FormListItem
                      key={index}
                      isBorder={index !== jvsSize - 1 || !this.props.disabled}
                    >
                      <FormElementContainer>
                        <FormElement
                          validate={getValidateMessage(
                            getValidate(index),
                            this.props.id
                          )}
                        >
                          <FormElementContainerItem>
                            <div className='FieldJvSetting__company-name'>
                              <FormElementContainerItemLabel>
                                会社名
                              </FormElementContainerItemLabel>
                              {this.props.disabled || !jv.onRegister ? (
                                <div>{jv.company_name}</div>
                              ) : (
                                <JvCompanyDropdown
                                  companyBranchId={this.props.companyBranchId}
                                  id={jv.company_id}
                                  value={jv.company_name}
                                  companyBranches={jv.companyBranches}
                                  disabled={this.props.disabled}
                                  onUpdate={item => {
                                    const updateFlg = this.setJvCompany(
                                      item,
                                      index
                                    );
                                    if (updateFlg === true) {
                                      newProps.onUpdate(this.state.jvsList);
                                    }
                                  }}
                                  onClear={item => {
                                    this.clearJvCompany(item, index);
                                  }}
                                  index={index}
                                />
                              )}
                            </div>
                            {(jv.companyBranches || jv.company_branch_name) && (
                              <div className='FieldJvSetting__company-branch-name'>
                                <FormElementContainerItemLabel isSpace={true}>
                                  支店名
                                </FormElementContainerItemLabel>
                                {this.props.disabled || !jv.onRegister ? (
                                  <div>{jv.company_branch_name}</div>
                                ) : (
                                  <JvCompanyBranchDropdown
                                    id={jv.company_branch_id}
                                    value={jv.company_branch_name}
                                    companyBranches={jv.companyBranches}
                                    companyFlg={
                                      jv.company_id === this.companyId
                                    }
                                    companyBranchId={this.props.companyBranchId}
                                    enable={_enable}
                                    detailFlg={this.props.detailFlg}
                                    onUpdate={item => {
                                      this.setJvCompanyBranch(item, index);
                                      newProps.onUpdate(this.state.jvsList);
                                    }}
                                    index={index}
                                  />
                                )}
                              </div>
                            )}
                            {!this.props.disabled && (
                              <div className='FieldJvSetting__delete-btn'>
                                <button
                                  className='btn--sm--negative'
                                  onClick={() => {
                                    this.removeJvForm(index, newProps);
                                  }}
                                >
                                  削除
                                </button>
                              </div>
                            )}
                          </FormElementContainerItem>
                        </FormElement>
                      </FormElementContainer>
                    </FormListItem>
                  );
                })}
                {!this.props.disabled && (
                  <FormListItem isBorder={false}>
                    <FormElementContainer>
                      <FormElementContainerItem>
                        <button
                          disabled={this.noValueJvFlg}
                          className={`btn-fixedsize--sub ${
                            this.noValueJvFlg ? 'btn-fixedsize--disabled' : ''
                          }`}
                          onClick={() => {
                            if (!this.noValueJvFlg) {
                              this.addJvForm();
                              let jvs = newProps.value;
                              jvs.push({});
                              newProps.onUpdate(jvs);
                            }
                          }}
                        >
                          追加する
                        </button>
                      </FormElementContainerItem>
                    </FormElementContainer>
                  </FormListItem>
                )}
              </FormElement>
            </FormListItem>
          )}
        </FormItem>
      </React.Fragment>
    );
  }
}

/**
 * @description 入退場管理機能 利用スイッチ
 */
export const UseEntranceSystem = props => {
  // console.log('FieldFormElements.jsx UseEntranceSystem ', props);

  if (
    !(
      checkProperty(props, 'value,onUpdate,disabled') ||
      checkProperty(props, 'value,onUpdate,disabled,EventMg')
    )
  ) {
    throw new Error('FieldFormElements.jsx UseEntranceSystem');
  }

  return (
    <FormListItem label='入退場管理機能'>
      <FormElement
        info={
          !props.disabled &&
          '入退場を利用される際は別途利用料が追加となります。料金につきましては、本社管理者または支店のご担当者までご確認ください。'
        }
      >
        {props.disabled ? (
          <span>{props.value === API_FLAG.On ? 'ON' : 'OFF'}</span>
        ) : (
          <div className='form-list-radio'>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <InputForm
                  name={'UseEntranceSystem'}
                  disabled={props.disabled}
                  onUpdate={props.onUpdate}
                  value={props.value === API_FLAG.On}
                  type='radio'
                  params={API_FLAG.On}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>ON</span>
              </label>
            </div>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <InputForm
                  name={'UseEntranceSystem'}
                  disabled={props.disabled}
                  onUpdate={props.onUpdate}
                  value={props.value === API_FLAG.Off}
                  type='radio'
                  params={API_FLAG.Off}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>OFF</span>
              </label>
            </div>
          </div>
        )}
      </FormElement>
    </FormListItem>
  );
};

/**
 * @description 労務安全機能 利用スイッチ
 */
export const UseGreenFileSystem = props => {
  if (
    !(
      checkProperty(props, 'value,onUpdate,disabled') ||
      checkProperty(props, 'value,onUpdate,disabled,EventMg') ||
      checkProperty(
        props,
        'value,onUpdate,disabled,EventMg,cannotOffGreenfileFlg'
      )
    )
  ) {
    throw new Error('FieldFormElements.jsx UseGreenFileSystem');
  }

  let helpText;
  if (!props.disabled) {
    helpText = messageUtility.getMessage('I-000-261');
  }
  if (props.cannotOffGreenfileFlg) {
    helpText = messageUtility.getMessage('I-000-262');
  }

  return (
    <FormListItem label='労務安全機能'>
      <FormElement info={helpText}>
        {props.disabled ||
        (props.cannotOffGreenfileFlg && props.value === API_FLAG.On) ? (
          <span>{props.value === API_FLAG.On ? 'ON' : 'OFF'}</span>
        ) : (
          <div className='form-list-radio'>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <InputForm
                  name={'UseGreenFileSystem'}
                  disabled={props.disabled}
                  onUpdate={props.onUpdate}
                  value={props.value === API_FLAG.On}
                  type='radio'
                  params={API_FLAG.On}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>ON</span>
              </label>
            </div>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <InputForm
                  name={'UseGreenFileSystem'}
                  disabled={props.disabled}
                  onUpdate={props.onUpdate}
                  value={props.value === API_FLAG.Off}
                  type='radio'
                  params={API_FLAG.Off}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>OFF</span>
              </label>
            </div>
          </div>
        )}
      </FormElement>
    </FormListItem>
  );
};

/**
 * @description 進捗・歩掛機能 利用スイッチ
 */
export const UseProgressSystem = props => {
  if (
    !(
      checkProperty(props, 'value,onUpdate,disabled') ||
      checkProperty(props, 'value,onUpdate,disabled,EventMg') ||
      checkProperty(props, 'value,onUpdate,disabled,EventMg,isUsingSpt')
    )
  ) {
    throw new Error('FieldFormElements.jsx UseProgressSystem');
  }
  let disabledEdit;
  let helpText;
  let radioClassName;
  let radioLabelClassName;
  if (!props.disabled) {
    helpText = messageUtility.getMessage('I-000-233');
  }
  if (props.isUsingSpt) {
    disabledEdit = true;
    radioClassName = 'radio-disabled';
    radioLabelClassName = 'label-radio--disabled';
    helpText = messageUtility.getMessage('I-000-234');
  }

  return (
    <FormListItem label='進捗・歩掛機能'>
      <FormElement info={helpText}>
        {props.disabled ? (
          <span>{props.value === API_FLAG.On ? 'ON' : 'OFF'}</span>
        ) : (
          <div className='form-list-radio'>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <InputForm
                  name={'UseProgressSystem'}
                  disabled={disabledEdit}
                  onUpdate={props.onUpdate}
                  value={props.value === API_FLAG.On}
                  type='radio'
                  params={API_FLAG.On}
                  className={radioClassName}
                />
                <RadioButtonIcon className='icon--2x' />
                <span className={radioLabelClassName}>ON</span>
              </label>
            </div>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <InputForm
                  name={'UseProgressSystem'}
                  disabled={disabledEdit}
                  onUpdate={props.onUpdate}
                  value={props.value === API_FLAG.Off}
                  type='radio'
                  params={API_FLAG.Off}
                  className={radioClassName}
                />
                <RadioButtonIcon className='icon--2x' />
                <span className={radioLabelClassName}>OFF</span>
              </label>
            </div>
          </div>
        )}
      </FormElement>
    </FormListItem>
  );
};

export const ContractorButton = ({ fieldId, onClickSystemUseHistory }) => {
  return (
    <FormListItem label='サービス利用履歴'>
      <FormElement>
        <PrimeContractorButton
          label='利用履歴を確認'
          buttonClass='btn--history btn-text--sm'
          onClick={e => {
            e.stopPropagation();
            onClickSystemUseHistory(fieldId);
          }}
        />
      </FormElement>
    </FormListItem>
  );
};

/**
 * @description NestForm で使う select コンポーネント
 */
const TimeSelectForm = props => (
  <React.Fragment>
    <select
      className='input-date-range__select--short'
      disabled={props.disabled}
      value={_.defaultTo(props.value, '')}
      onChange={e => {
        props.onUpdate(e.target.value);
      }}
    >
      <option value={false}>---</option>
      <SelectOptionTimeTemplate
        id={`timeselectforms-${props.id}`}
        start='00:00'
        end='23:45'
        step={15}
      />
    </select>
    <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
  </React.Fragment>
);

/**
 *
 * 共通コンポーネント
 */

/***
 * SelectBoxをCcus用に拡張
 */
class SelectBoxWithOnUpdate extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <SelectBox
        {...this.props}
        onChange={event => {
          if (this.props.onUpdate) {
            this.props.onUpdate(event.target.value);
          }
          this.props.onValidationCheck(event.target.value);
        }}
      />
    );
  }
}

/**
 * @description セレクト共通
 */
export const _FieldSelectCommon = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem
        label={
          props.labelTitle +
          (!_.isUndefined(props.children) ? `\n${props.children}` : '')
        }
        ccusRequired={
          _.has(props, 'ccusRequired') && props.ccusRequired === true
        }
      >
        <FormElement
          ccusComponent={props.ccusFormElement}
          validate={getValidateMessage(props.validate, props.id)}
        >
          <CcusProvider {...newProps} {...props}>
            <SelectBoxWithOnUpdate
              value={props.value || props.default_value}
              valueName={'id'}
              keyName={'name'}
              itemName={'name'}
              disabled={props.disabled}
              onValidationCheck={newProps.onValidationCheck}
              isFormListDefaultItem={props.isFormListDefaultItem}
            />
          </CcusProvider>
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);

export const FieldSelectCommon = withState(params => {
  return { value: params.defaultValue };
})(_FieldSelectCommon);

/**
 * @description テキスト入力共通
 */
export const FieldInputCommon = props => (
  <FormItem {...props}>
    {newProps => (
      <FormListItem
        label={
          props.labelTitle +
          (!_.isUndefined(props.children) ? `\n${props.children}` : '')
        }
        required={!props.disabled && props.required}
        ccusRequired={
          _.has(props, 'ccusRequired') && props.ccusRequired === true
        }
      >
        <FormElement
          ccusComponent={props.ccusFormElement}
          validate={getValidateMessage(props.validate, props.id)}
        >
          <CcusProvider {...newProps} {...props}>
            <InputForm
              value={props.value || props.default_value}
              disabled={props.disabled}
              placeholder={props.placeholder}
            />
          </CcusProvider>
        </FormElement>
      </FormListItem>
    )}
  </FormItem>
);



// WEBPACK FOOTER //
// ./src/components/FieldFormElements.jsx